import { lazy } from "react";

export const PDFViewer = lazy(() => import("./PDFViewer.tsx"));
